/**
 * Site Hero
 */

'use strict';

// Listen for alpine.js ready
document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'siteHero', () => ({

		mobile    : false,
		desktop   : false,
		search    : false,
		showSubnav: false,
		sticky    : false,
		sliderShow: false,

		init() {

			// Use resize observer to measure the total height of the
			// site-hero-subnav element.
			const siteHeroSubnav = document.getElementById( 'site-hero-subnav' );
			const resizeObserver = new ResizeObserver( entries => {
				for ( let entry of entries ) {
					document.body.style.setProperty( '--subnav-height', entry.contentRect.height + 'px' );
				}
			});

			// Observe the site-hero-subnav element.
			resizeObserver.observe( siteHeroSubnav );

			// Unhide the slider after the page has loaded.
			window.addEventListener( 'load', () => {
				this.sliderShow = true;
			});
		},

		scrollToSubnav() {
			const rect   = this.$refs.subnavMenu.getBoundingClientRect();
			const offset = rect.bottom - window.innerHeight;
			if ( 0 < offset ) window.scrollTo( 0, window.scrollY + offset );
		}

	}) );
});
